import { CircularProgress, ListItemButton } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ListItemText from "@mui/material/ListItemText";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import LeftIcon from "./Assets/Images/left.svg";
import RightIcon from "./Assets/Images/right.svg";
import Tick from "./Assets/Images/tick.svg";
import { publish } from "./events";
import getTenantIdFromURL from "./utils/getTenantIdFromURL";
import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import Close from "./Assets/Images/close.svg";
import { formatCurrency } from "./utils/Helper.js";
import SearchIcon from "@mui/icons-material/Search";
import { findRelatedCompanies, updateCompany } from "./api/companyApi";
import { getTenantById } from "./api/tenantApi";

function VerifyEntityModal(props) {
  const {
    handleDelete,
    companyUniqueID = "",
    onClose,
    onDunsIdSelect,
    companyInfo,
    requestedLimit,
    companyName,
    country,
  } = props;
  console.log("requested limit from porps", requestedLimit);

  const [companySearchResults, setCompanySearchResults] = useState([]);
  const navigate = useNavigate()
  const [error, setError] = useState(false);
  const [errorTxt, setErrorTxt] = useState("This field is required");
  const location = useLocation();

  function isValid(value) {
    return (
      value !== null &&
      value !== undefined &&
      value !== "" &&
      !Number.isNaN(value) &&
      value !== "NaN" &&
      value !== Infinity
    );
  }

  const initilRequestLimit = () => {
    console.log("inside ");
    if (requestedLimit) {
      const reqLimit = isValid(requestedLimit)
        ? parseFloat(requestedLimit)
        : "";
      console.log("inside initil request limit", reqLimit);
      if (isValid(reqLimit)) {
        return formatCurrency(reqLimit);
      }
    }
    return "";
  };
  console.log("after requ limit", initilRequestLimit());

  const [currentTenant, setCurrentTenant] = useState(null);
  const [loading, setLoading] = useState(false);

  //Parent company values
  const [parentSelectedCompany, setParentSelectedCompany] = useState("");
  const [addCompanyWithoutParent, setAddCompanyWithoutParent] = useState(true);

  const [modalOpen, setModalOpen] = useState(false);
  const [tenantId, setTenantId] = useState();

  const isAdmin = useSelector((state) => state.userInfo.isAdmin);
  const URLTenant = getTenantIdFromURL();
  const currentTenantId = useSelector((state) => state.userInfo.tenantId);
  // const tenantEmail = useSelector((state) => {
  //   const email = state.userInfo.email;
  //   if (email && typeof email === 'string') {
  //     const username = email.split("@")[0];
  //     return username.length > 5 ? `${username.slice(0, 5)}..` : username;
  //   }
  //   return null;
  // });

  const selectTenantId = () => {
    if (isAdmin) setTenantId(URLTenant);
    else setTenantId(currentTenantId);
  };

  const [showLeftButton, setShowLeftButton] = useState(false);
  const [creditLimits, setCreditLimits] = useState({});

  const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[700] : "#E9E9E9",
    zIndex: 1,
    color: "#fff",
    width: 45,
    height: 45,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    boxShadow: "0px 3px 6px #00000029",
    ...(ownerState.active && {
      backgroundColor: "#2F3D63",
      boxShadow: "0px 3px 6px #00000029",
      border: "2px solid #5186EC",
    }),
    ...(ownerState.completed && {
      backgroundColor: "#2F3D63",
      boxShadow: "0px 3px 6px #00000029",
    }),
  }));

  function ColorlibStepIcon(props) {
    const { active, completed, className, icon } = props;

    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}>
        {completed ? (
          <img src={Tick} width={25} alt='' />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            <span
              style={{
                color: active ? "#fff" : "#777A82",
                fontSize: "18px",
                fontWeight: "500",
              }}>
              {icon}
            </span>
          </div>
        )}
      </ColorlibStepIconRoot>
    );
  }

  ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
  };

  const listRef = useRef(null);
  const [isScrolling, setIsScrolling] = useState(false);

  const handleScroll = () => {
    if (listRef.current) {
      const newScrollLeft = listRef.current.scrollLeft;
      setShowLeftButton(newScrollLeft > 0);
      setIsScrolling(false);
    }
  };

  const scrollListLeft = useCallback(() => {
    if (listRef.current) {
      const scrollAmount = 705;
      const newScrollLeft = Math.max(
        0,
        listRef.current.scrollLeft - scrollAmount
      );
      listRef.current.scrollTo({
        left: newScrollLeft,
        behavior: "smooth",
      });

      setIsScrolling(true);
      listRef.current.addEventListener("scroll", handleScroll);
    }
  }, [listRef]);

  const scrollListRight = useCallback(() => {
    if (listRef.current) {
      const scrollAmount = 705;
      listRef.current.scrollTo({
        left: listRef.current.scrollLeft + scrollAmount,
        behavior: "smooth",
      });
      listRef.current.addEventListener("scroll", handleScroll);
    }
  }, [listRef]);

  useEffect(() => {
    return () => {
      if (listRef.current) {
        listRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, [listRef]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "833px",
    bgcolor: "background.paper",
    borderRadius: "20px",
    boxShadow: "inset 0px 1px 3px #0000001A, 0px 3px 6px #00000029",
  };

  const modalStyle = {
    backdropFilter: "blur(2px)",
    backgroundColor: "rgb(255, 255, 255, 0.5)",
  };

  const companyListStyle = {
    //  height:"263px",
    minWidth: "225px",
    maxWidth: "225px",
    border: "1px solid #E9E9E9",
    boxShadow: "0px 1px 3px #00000029",
    borderRadius: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    // margin:"5px",
  };

  const handleAddCompany = async (event) => {
    await handleAddCompanyClick();
    handleClose();
    if (props.open) return;
  };

  useEffect(() => {
    async function run() {
      await getCurrentTenant();
    }
    run();
    selectTenantId();
  }, [tenantId]);

  const handleAddCompanyClick = async () => {
    if (props?.open) {
      companyAdded();
      handleOptionsModalClose();
      onDunsIdSelect(selectedCompanies[0]?.organization?.duns);
      return;
    }
    
    if (parentSelectedCompany === null) {
      setAddCompanyWithoutParent(true);
    }
    
    // Check for single company selection
    if (selectedCompanies?.length === 0) {
      toast.error("Please select a company");
      setError(true);
      return;
    }
    
    // Since it's single select, we only need to process one company
    const selectedCompany = selectedCompanies[0]; // Get the single selected company
    
    const companyDuns = selectedCompany.organization
      ? selectedCompany.organization.duns
      : null;
    const companyTicker = selectedCompany.organization
      ? selectedCompany?.organization?.tickerSymbol
      : selectedCompany?.ticker.data;
    
    try {
      await updateCompany(companyInfo.companyId, {
        tenantId: tenantId,
        dnbCompanyId: companyDuns,
        view: 1,
        ticker: companyTicker || "",
        country:
          selectedCompany?.organization?.primaryAddress?.addressCountry
            ?.name || "",
        requestedCreditLimit: parseFloat(initilRequestLimit()),
        parentCompanyName:
          parentSelectedCompany?.organization?.primaryName || "",
        parentDnbCompanyId: parentSelectedCompany?.organization?.duns || "",
        parentCountry:
          parentSelectedCompany?.organization?.primaryAddress
            ?.addressCountry?.name || "",
        parentTicker:
          parentSelectedCompany?.organization?.tickerSymbol || "",
      });
      
      console.log("Company updated successfully");
      handleOptionsModalClose();
      toast.success(`${companyInfo?.companyName} Updated Successfully `, {
        bodyStyle: {
          fontWeight: "bold",
        },
      });
      companyAdded();
    } catch (error) {
      console.error("Error updating company:", error);
      toast.error("Error updating company");
    }

    setParentSelectedCompany(null);
    setSelectedCompanies([]);
  };

  const companyAdded = () => {
    setError(false);
  };

  const handleClose = async () => {
    setError(false);

    publish("create_company", {});
    setSelectedCompanies([]);
  };

  const getCurrentTenant = async () => {
    if (tenantId) {
      try {
        const response = await getTenantById(tenantId);
        setCurrentTenant(response?.data);
      } catch (error) {
        console.error("Error fetching tenant:", error);
      }
    }
  };

  const getRelatedCompany = async () => {
    const companyName = companyInfo?.companyName;
    const dnbCompanyId = companyInfo?.dnbCompanyId;

    console.log("Finding related companies for:", { companyName, dnbCompanyId });

    try {
      const result = await findRelatedCompanies({
        companyName,
        dnbCompanyId,
        tenantId: currentTenant?.id
      });

      if (result && result.data && Array.isArray(result.data.searchCandidates)) {
        const candidates = result.data.searchCandidates;
        let filteredResult = candidates.filter((element) => {
          const orgName = element?.organization?.primaryName?.toLowerCase() || "";
          const companyNameMatch = !companyName || orgName.includes(companyName.toLowerCase());

          return companyNameMatch;
        });

        if (!filteredResult || filteredResult.length === 0) {
          // No filtered results found, use all candidates (could be empty)
          filteredResult = candidates;
        }

        setCompanySearchResults(filteredResult);
      } else {
        setCompanySearchResults([]);
      }
    } catch (error) {
      console.error("Error finding related companies:", error);
      setCompanySearchResults([]);
    }
  };

  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const handleCheckboxChange = (company) => {
    // Single select logic - replace the existing company or clear if same company
    if (selectedCompanies.some(
      (selected) => selected.organization.duns === company.organization.duns
    )) {
      // If clicking the same company, deselect it
      setSelectedCompanies([]);
      setCreditLimits({});
    } else {
      // Select only this company (single select)
      setSelectedCompanies([company]);
      setCreditLimits({
        [company.organization.duns]: "",
      });
    }
  };

  const handleOptionsModalOpen = async () => {
    try {
      setLoading(true);
      setModalOpen(true);
      await getRelatedCompany();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error opening modal:", error);
      toast.error("Error loading related companies");
    }
  };

  const handleOptionsModalClose = () => {
    setSelectedCompanies([]);
    setModalOpen(false);
    setShowLeftButton(false);
    if (props.open) onClose();
  };

  const verifiedCompany = companySearchResults.find(
    (company) => company.organization.duns === companyUniqueID
  );
  
  const otherCompanies = companySearchResults.filter(
    (company) => company.organization.duns !== companyUniqueID
  );
  
  // Combine the verified company and other companies
  const allCompanies = verifiedCompany
    ? [verifiedCompany, ...otherCompanies]
    : otherCompanies;

  return (
    <>
        <Button
          onClick={handleOptionsModalOpen}
          style={{
            color: loading ? "grey" : "#5186EC",
            minWidth: "110px",
            height: "17px",
            fontSize: "14px",
            textTransform: "none",
            fontFamily: "Rubik, sans-serif",
            fontWeight: "250",
            display: "flex",
            alignItems: "center",
            whiteSpace: "nowrap",
          }}
          disabled={loading}
          sx={{
            display: isAdmin && location.pathname === "/" ? "none" : "inline",
          }}
          startIcon={<SearchIcon style={{ color: "#5186EC" }} />}
          >
          Verify Entity
        </Button>
        <Modal
          open={modalOpen || props.open}
          style={modalStyle}
          onClose={handleOptionsModalClose}>
          <div style={{ color: "#2F3D63" }}>
            <Box sx={style}>
              <button
                style={{ position: "absolute", top: "20px", left: "30px" }}
                onClick={handleOptionsModalClose}>
                <img
                  style={{ width: "23px", height: "23px" }}
                  src={Close}
                  alt=''
                />
              </button>
              <Typography
                id='modal-modal-title'
                variant='h6'
                component='h2'
                sx={{
                  textAlign: "center",
                  padding: 2,
                  color: "#2F3D63",
                }}>
                Verify Entity
              </Typography>

              <div style={{ display: "flex", justifyContent: "center" }}>
                {loading ? (
                  <div
                    style={{
                      padding: "20px",
                      paddingTop: "30px",
                      paddingBottom: "20px",
                    }}>
                    <CircularProgress size={24} />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "8px",
                    }}>
                    <Typography variant='h6' sx={{ marginTop: "10px" }}>
                      Search Results
                    </Typography>
                    <Typography
                      variant='subtitle1'
                      color='textSecondary'
                      sx={{ fontSize: "12px" }}>
                      {companySearchResults?.length} companies found
                    </Typography>
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          maxWidth: "705px",
                          overflow: "hidden",
                          display: "flex",
                          gap: "10px",
                          width: "1920px",
                        }}
                        ref={listRef}>
                        {companySearchResults ?.map((company, index) => {
                          let showVerifiedCompany =
                            companyUniqueID &&
                            company.organization.duns === companyUniqueID;
                          return (
                            <div
                              style={{
                                ...companyListStyle,
                                border: showVerifiedCompany
                                  ? "2px solid #101049"
                                  : "1px solid #E9E9E9",
                              }}
                              key={index}>
                              <ListItemButton
                                style={{
                                  border: 1,
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  width: "225px",
                                }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}>
                                  {!showVerifiedCompany && (
                                    <input
                                      type='radio'
                                      name="companySelection"
                                      style={{
                                        marginLeft: 0,
                                        marginRight: "8px",
                                        border: "1px solid #E9E9E9",
                                      }}
                                      checked={selectedCompanies.some(
                                        (selected) =>
                                          selected.organization.duns ===
                                          company.organization.duns
                                      )}
                                      onChange={() =>
                                        handleCheckboxChange(company)
                                      }
                                    />
                                  )}

                                  <ListItemText
                                    primaryTypographyProps={{
                                      fontSize: 14,
                                      fontWeight: "bold",
                                    }}
                                    primary={company.organization.primaryName}
                                  />
                                </div>
                                <div>
                                  {company?.organization?.tickerSymbol && (
                                    <ListItemText
                                      secondaryTypographyProps={{
                                        fontSize: 12,
                                        color: "#1A2A56",
                                      }}
                                      secondary={`Ticker - ${company?.organization?.tickerSymbol}`}
                                    />
                                  )}
                                  <ListItemText
                                    secondaryTypographyProps={{
                                      fontSize: 12,
                                      color: "#1A2A56",
                                    }}
                                    secondary={`Street - ${company?.organization?.primaryAddress.streetAddress?.line1}`}
                                  />
                                  {company?.organization?.primaryAddress
                                    .addressLocality?.name && (
                                    <ListItemText
                                      secondaryTypographyProps={{
                                        fontSize: 12,
                                        color: "#1A2A56",
                                      }}
                                      secondary={`City - ${company?.organization?.primaryAddress.addressLocality?.name}`}
                                    />
                                  )}
                                  {company?.organization?.primaryAddress
                                    .addressRegion?.name && (
                                    <ListItemText
                                      secondaryTypographyProps={{
                                        fontSize: 12,
                                        color: "#1A2A56",
                                      }}
                                      secondary={`State - ${company?.organization?.primaryAddress.addressRegion?.name}`}
                                    />
                                  )}
                                  <ListItemText
                                    secondaryTypographyProps={{
                                      fontSize: 12,
                                      color: "#1A2A56",
                                    }}
                                    secondary={`Country - ${company?.organization?.primaryAddress?.addressCountry?.name}`}
                                  />
                                  {company?.organization?.primaryAddress
                                    ?.postalCode && (
                                    <ListItemText
                                      secondaryTypographyProps={{
                                        fontSize: 12,
                                        color: "#1A2A56",
                                      }}
                                      secondary={`Zip Code - ${company?.organization?.primaryAddress?.postalCode}`}
                                    />
                                  )}
                                </div>
                              </ListItemButton>
                            </div>
                          );
                        })}
                      </div>
                      {showLeftButton ? (
                        <button
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "-35px",
                            transform: "translateY(-50%)",
                            zIndex: 1,
                          }}
                          onClick={scrollListLeft}>
                          <img src={LeftIcon} alt='' />
                        </button>
                      ) : null}

                      {companySearchResults?.length > 3 ? (
                        <button
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "-30px",
                            transform: "translateY(-50%)",
                            zIndex: 1,
                          }}
                          onClick={scrollListRight}>
                          <img src={RightIcon} alt='' />
                        </button>
                      ) : null}
                    </div>
                    <div
                      style={{ margin: "20px 0 30px 0", textAlign: "center" }}>
                      <Button
                        variant='contained'
                        sx={{
                          width: "200px",
                          height: "36px",
                          marginLeft: "10px",
                          // border: "1px solid #5186EC",
                          borderRadius: "8px",
                          backgroundColor: "#5186EC",
                          "&:disabled": {
                            backgroundColor: "#f0f0f0",
                          },
                          "&:hover": {
                            backgroundColor: "#5186EC", // Same color on hover
                          },
                        }}
                        disabled={false}
                        onClick={handleAddCompany}>
                        Add and Complete
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Box>
          </div>
        </Modal>
    </>
  );
}

export default VerifyEntityModal;
